import NewsTipLocation from './NewsTipLocation'

export default NewsTipLocation
